export default "__VITE_ASSET__CejcMXda__"